import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { SD_TReference, SD_TReferenceId } from '../SD/SD.targets'

export function IDB_smartDataReferenceRead(reference: SD_TReferenceId) {
    return IDB_rowRead<SD_TReference>(IDB_globalDb, 'smart_data_references', reference)
}

export function IDB_smartDataReferencesDelete(reference: SD_TReferenceId[]) {
    return IDB_rowsDelete(IDB_globalDb, 'smart_data_references', reference)
}

export function IDB_smartDataReferencesReadAll() {
    return IDB_rowsReadAll<SD_TReference>(IDB_globalDb, 'smart_data_references')
}

export function IDB_smartDataReferencesWrite(smartDataReferences: SD_TReference[]) {
    return IDB_rowsWrite(IDB_globalDb, 'smart_data_references', smartDataReferences)
}
